// Work page: one featured piece with an image viewer; clicking a work in the grid swaps it in.
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initPanel(panel) {
    var main = panel.querySelector('[data-main]');
    var count = panel.querySelector('[data-count]');
    var thumbs = Array.prototype.slice.call(panel.querySelectorAll('[data-thumb]'));
    var i = 0;
    function show(n) {
      if (!thumbs.length || !main) return;
      i = (n + thumbs.length) % thumbs.length;
      var t = thumbs[i];
      if (t.dataset.full) {
        main.src = t.dataset.full;
        main.alt = t.dataset.alt || '';
      }
      thumbs.forEach(function (x, k) { x.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
      if (count) count.textContent = (i + 1) + ' / ' + thumbs.length;
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var prev = panel.querySelector('[data-prev]');
    var next = panel.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
    panel.addEventListener('keydown', function (e) {
      if (e.target.closest && e.target.closest('input, textarea')) return;
      if (e.key === 'ArrowLeft') { show(i - 1); }
      if (e.key === 'ArrowRight') { show(i + 1); }
    });
    panel._reset = function () { show(0); };
  }

  function initSeries(root) {
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-work-panel]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-work-card]'));
    var anchor = root.querySelector('[data-viewer-anchor]');
    if (!panels.length) return;
    panels.forEach(initPanel);

    function feature(id, scroll) {
      var match = panels.some(function (p) { return p.dataset.workPanel === id; });
      if (!match) return false;
      panels.forEach(function (p) {
        var on = p.dataset.workPanel === id;
        p.hidden = !on;
        if (on && p._reset) p._reset();
      });
      cards.forEach(function (c) { c.hidden = c.dataset.workCard === id; });
      if (history.replaceState) history.replaceState(null, '', '#' + id);
      if (scroll && anchor) anchor.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      return true;
    }

    root.addEventListener('click', function (e) {
      var link = e.target.closest('[data-feature]');
      if (!link || !root.contains(link)) return;
      if (feature(link.dataset.feature, true)) e.preventDefault();
    });

    root._feature = feature;

    var hash = decodeURIComponent((location.hash || '').slice(1));
    if (hash && feature(hash, false)) {
      if (anchor) anchor.scrollIntoView();
    } else {
      feature(panels[0].dataset.workPanel, false);
      if (history.replaceState) history.replaceState(null, '', location.pathname + location.search);
    }
  }

  function boot(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-series]'), initSeries);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  // Theme editor: re-run when a section reloads, and show a work when its block is selected.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var panel = e.target.closest && e.target.closest('[data-work-panel]');
    var root = panel && panel.closest('[data-series]');
    if (root && root._feature) root._feature(panel.dataset.workPanel, false);
  });
})();
